import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import ContractDocumentsModal from './ContractDocumentsModal';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import DateObject from 'react-date-object';
import CustomObligationModal from './CustomObligationModal';
import ObligationSelectorModal from './ObligationSelectorModal';
import NumberFormat from 'react-number-format';

export default class Contract extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'contract',
            id: this.props.Id,
            loading: true,
            lockScreen: 0,
            customers: [],
            data: null,
            services: [],
            record: {
                id: 0,
                customerId: '',
                contractNumber: '',
                startDate: null,
                endDate: null,
                amount: '',
                fiscalYear: new Date().getFullYear(),
                serviceIds: [],
                payments: []
            },
            showDocsModal: false,
            showCustomObligationModal: false,
            showObligationModal: false,
            activeTab: 'info',          // 'info' | 'activity'
            tasksActivity: [],
            loadingActivity: false,
            expandedTaskId: null
        };
    }

    componentDidMount() { this.loadData(); }

    // ====================== DATA ======================
    async loadData() {
        const currentId = this.getCurrentFormId();
        this.httpPost(`api/v1/${this.state.controllerName}/get`, { id: currentId })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const rec = data.record;

                    if (rec.startDate) rec.startDate = new DateObject({
                        date: rec.startDate, format: 'YYYY/MM/DD', calendar: persian, locale: persian_fa,
                    });
                    if (rec.endDate) rec.endDate = new DateObject({
                        date: rec.endDate, format: 'YYYY/MM/DD', calendar: persian, locale: persian_fa,
                    });
                    if (rec.payments) rec.payments = rec.payments.map(p => ({
                        ...p,
                        paymentDate: p.paymentDatePersian ? new DateObject({
                            date: p.paymentDatePersian,
                            format: 'YYYY/MM/DD',
                            calendar: persian,
                            locale: persian_fa,
                        }) : null,
                    }));

                    this.setState({
                        record: rec,
                        customers: data.customers,
                        services: data.services,
                        loading: false,
                        data: data
                    });
                } else if (data.status === -5) window.location.href = "/access-denied";
                else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    // ====================== ACTIVITY ======================
    loadContractActivity = () => {
        if (!this.state.record.id) return;
        this.setState({ loadingActivity: true });
        this.httpPost('api/v1/contract/activity', { contractId: this.state.record.id })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ tasksActivity: data.tasks, loadingActivity: false });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loadingActivity: false });
                }
            });
    };

    toggleTaskDetail = (taskId) => {
        this.setState(prev => ({
            expandedTaskId: prev.expandedTaskId === taskId ? null : taskId
        }));
    };

    // ====================== HANDLERS ======================
    handleChange(field, value) {
        this.setState({ record: { ...this.state.record, [field]: value } });
    }

    toggleService(serviceId) {
        const current = [...this.state.record.serviceIds];
        const index = current.indexOf(serviceId);
        if (index > -1) current.splice(index, 1);
        else current.push(serviceId);
        this.setState({ record: { ...this.state.record, serviceIds: current } });
    }

    addPayment() {
        const payments = [...this.state.record.payments];
        payments.push({
            id: 0,
            amount: '',
            paymentDate: null,
            description: '',
            isReceived: false
        });
        this.setState({ record: { ...this.state.record, payments } });
    }

    removePayment(index) {
        const payments = [...this.state.record.payments];
        payments.splice(index, 1);
        this.setState({ record: { ...this.state.record, payments } });
    }

    handlePaymentChange(index, field, value) {
        const payments = [...this.state.record.payments];
        payments[index] = { ...payments[index], [field]: value };
        this.setState({ record: { ...this.state.record, payments } });
    }

    toShamsiString(dateObj) {
        if (!dateObj) return '';
        return dateObj.format('YYYY/MM/DD');
    }

    // ====================== SAVE ======================
    async save(e) {
        e.preventDefault();
        this.setState({ lockScreen: 1 });

        const recordToSend = {
            ...this.state.record,
            startDate: this.toShamsiString(this.state.record.startDate),
            endDate: this.state.record.endDate ? this.toShamsiString(this.state.record.endDate) : '',
            customerId: this.state.record.customerId.toString(),
            amount: this.state.record.amount.toString(),
            payments: this.state.record.payments.map(p => ({
                ...p,
                paymentDate: this.toShamsiString(p.paymentDate),
                amount: p.amount.toString()
            }))
        };

        this.httpPost(`api/v1/${this.state.controllerName}/save`, recordToSend)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage('قرارداد با موفقیت ذخیره شد');
                    this.setState({ redirect: '/contracts' });
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    // ====================== RENDER ======================
    renderForm() {
        const { record, customers, services, activeTab, tasksActivity, loadingActivity, expandedTaskId } = this.state;
        const isEdit = record.id > 0;

        const statusColors = {
            1: '#ffc107', 2: '#fd7e14', 3: '#0d47a1', 4: '#e74c3c', 5: '#28a745'
        };

        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">{isEdit ? `ویرایش قرارداد شماره ${record.contractNumber}` : 'افزودن قرارداد جدید'}</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/contracts/" className="btn btn-dim btn-outline-light"><em className="icon ni ni-arrow-left"></em><span>بازگشت</span></NavLink>
                        </div>
                    </div>
                </div>

                {/* ============= TABS (only edit) ============= */}
                {isEdit && (
                    <ul className="nav nav-tabs mb-3" style={{ borderBottomColor: 'rgba(255,255,255,0.1)' }}>
                        <li className="nav-item">
                            <a className={`nav-link ${activeTab === 'info' ? 'active' : ''}`}
                                onClick={() => this.setState({ activeTab: 'info' })}
                                style={activeTab === 'info' ? {
                                    backgroundColor: 'rgba(99, 102, 241, 0.2)',
                                    borderColor: 'rgba(99, 102, 241, 0.4)',
                                    color: '#e0e7ff',
                                    borderRadius: '8px 8px 0 0',
                                    fontWeight: 500,
                                    backdropFilter: 'blur(10px)'
                                } : {
                                    color: '#94a3b8',
                                    borderColor: 'transparent',
                                    transition: 'all 0.2s'
                                }}>
                                اطلاعات قرارداد
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${activeTab === 'activity' ? 'active' : ''}`}
                                onClick={() => { this.setState({ activeTab: 'activity' }); this.loadContractActivity(); }}
                                style={activeTab === 'activity' ? {
                                    backgroundColor: 'rgba(99, 102, 241, 0.2)',
                                    borderColor: 'rgba(99, 102, 241, 0.4)',
                                    color: '#e0e7ff',
                                    borderRadius: '8px 8px 0 0',
                                    fontWeight: 500,
                                    backdropFilter: 'blur(10px)'
                                } : {
                                    color: '#94a3b8',
                                    borderColor: 'transparent',
                                    transition: 'all 0.2s'
                                }}>
                                فعالیت‌ها ({tasksActivity.length})
                            </a>
                        </li>
                    </ul>
                )}

                {/* ============= TAB INFO ============= */}
                {activeTab === 'info' && (
                    <form onSubmit={e => this.save(e)}>
                        <div className="nk-block">
                            <div className="card card-bordered">
                                <div className="card-inner">
                                    <h5 className="card-title">اطلاعات اصلی</h5>
                                    <div className="row g-4">
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label className="form-label">مشتری <span className="text-danger">*</span></label>
                                                <select className="form-select" value={record.customerId} onChange={e => this.handleChange('customerId', e.target.value)}>
                                                    <option value="">-- انتخاب مشتری --</option>
                                                    {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label className="form-label">شماره قرارداد <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={record.contractNumber} onChange={e => this.handleChange('contractNumber', e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label className="form-label">تاریخ شروع</label>
                                                <DatePicker calendar={persian} locale={persian_fa} value={record.startDate}
                                                    onChange={date => this.handleChange('startDate', date)} format="YYYY/MM/DD" inputClass="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label className="form-label">تاریخ پایان</label>
                                                <DatePicker calendar={persian} locale={persian_fa} value={record.endDate}
                                                    onChange={date => this.handleChange('endDate', date)} format="YYYY/MM/DD" inputClass="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label className="form-label">سال مالی</label>
                                                <input type="number" className="form-control" value={record.fiscalYear} onChange={e => this.handleChange('fiscalYear', e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label className="form-label">مبلغ قرارداد (تومان)</label>
                                                <NumberFormat style={{ fontSize: "14px" }}
                                                    value={record.amount === 0 ? '0' : record.amount}
                                                    onValueChange={(values) => this.handleChange('amount', values.floatValue || 0)}
                                                    thousandSeparator={true} prefix={''}
                                                    className='form-control text-center ltr' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-bordered mt-3">
                                <div className="card-inner">
                                    <h5 className="card-title">خدمات تحت پوشش</h5>
                                    <div className="row">
                                        {services.map(svc => (
                                            <div className="col-md-4 col-lg-3" key={svc.id}>
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id={`svc_${svc.id}`} checked={record.serviceIds.includes(svc.id)} onChange={() => this.toggleService(svc.id)} />
                                                    <label className="custom-control-label" htmlFor={`svc_${svc.id}`}>{svc.title}</label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="card card-bordered mt-3">
                                <div className="card-inner">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h5 className="card-title mb-0">اقساط / پرداخت‌ها</h5>
                                        <button type="button" className="btn btn-sm btn-primary" onClick={() => this.addPayment()}><em className="icon ni ni-plus"></em> افزودن قسط</button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr><th>تاریخ</th><th>مبلغ</th><th>توضیح</th><th>دریافت شده</th><th></th></tr>
                                            </thead>
                                            <tbody>
                                                {record.payments.map((p, idx) => (
                                                    <tr key={idx}>
                                                        <td>
                                                            <DatePicker calendar={persian} locale={persian_fa} value={p.paymentDate} portal={true} offsetY={5}
                                                                zIndex={9999}
                                                                onChange={date => this.handlePaymentChange(idx, 'paymentDate', date)}
                                                                format="YYYY/MM/DD" inputClass="form-control" />
                                                        </td>
                                                        <td>
                                                            <NumberFormat style={{ fontSize: "14px" }}
                                                                value={p.amount === 0 ? '0' : p.amount}
                                                                onValueChange={(values) => this.handlePaymentChange(idx, 'amount', values.floatValue || 0)}
                                                                thousandSeparator={true} prefix={''}
                                                                className='form-control text-center ltr' />
                                                        </td>
                                                        <td><input type="text" className="form-control" value={p.description} onChange={e => this.handlePaymentChange(idx, 'description', e.target.value)} /></td>
                                                        <td className="text-center">
                                                            <input type="checkbox" checked={p.isReceived} onChange={e => this.handlePaymentChange(idx, 'isReceived', e.target.checked)} />
                                                        </td>
                                                        <td><button type="button" className="btn btn-sm btn-danger" onClick={() => this.removePayment(idx)}><em className="icon ni ni-cross"></em></button></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-3">
                                <button type="submit" className="btn btn-primary" disabled={this.state.lockScreen === 1}>
                                    {this.state.lockScreen === 1 && <span className="spinner-border spinner-border-sm mr-2"></span>}
                                    <em className="icon ni ni-save"></em> ذخیره
                                </button>
                                {isEdit && (
                                    <>
                                        <button type="button" className="btn btn-outline-info ms-2" onClick={() => this.setState({ showDocsModal: true })}>
                                            <em className="icon ni ni-folder"></em> مدارک
                                        </button>
                                        <button type="button" className="btn btn-outline-info ms-2" onClick={() => this.setState({ showObligationModal: true })}>
                                            <em className="icon ni ni-task"></em> افزودن تکلیف
                                        </button>
                                        <button type="button" className="btn btn-outline-info ms-2"
                                            onClick={() => window.open(`/contract/print/${record.id}`, '_blank')}>
                                            <em className="icon ni ni-printer"></em> چاپ
                                        </button>
                                    </>
                                )}
                                <NavLink to="/contracts/" className="btn btn-dim btn-outline-light ms-2"><em className="icon ni ni-cross"></em> انصراف</NavLink>
                            </div>
                        </div>
                    </form>
                )}

                {/* ============= TAB ACTIVITY ============= */}
                {activeTab === 'activity' && (
                    <div className="mt-3">
                        {loadingActivity ? this.renderLoading() : (
                            tasksActivity.length === 0 ? (
                                <div className="alert alert-info">هیچ وظیفه‌ای با فعالیت ثبت‌شده وجود ندارد.</div>
                            ) : (
                                    <div className="activity-timeline">
                                        {tasksActivity.map(task => (
                                            <div key={task.id}
                                                className="card mb-3"
                                                style={{
                                                    backgroundColor: 'rgba(30, 41, 59, 0.75)',
                                                    backdropFilter: 'blur(12px)',
                                                    WebkitBackdropFilter: 'blur(12px)',
                                                    border: '1px solid rgba(255,255,255,0.1)',
                                                    borderRadius: '16px',
                                                    color: '#e2e8f0'
                                                }}>
                                                <div className="card-inner">
                                                    <div className="d-flex justify-content-between align-items-start"
                                                        onClick={() => this.toggleTaskDetail(task.id)}
                                                        style={{ cursor: 'pointer' }}>
                                                        <div>
                                                            <span className="badge" style={{ backgroundColor: statusColors[task.status], color: '#fff' }}>
                                                                {task.statusText}
                                                            </span>
                                                            <strong className="ms-2" style={{ color: '#f1f5f9' }}>{task.title}</strong>
                                                            <div className="small mt-1" style={{ color: '#94a3b8' }}>
                                                                مجری: {task.assignedTo} | مدت: {task.duration}
                                                                {task.commentsCount > 0 && ` | 💬 ${task.commentsCount}`}
                                                                {task.documentsCount > 0 && ` | 📎 ${task.documentsCount}`}
                                                            </div>
                                                        </div>
                                                        <em className={`icon ni ${expandedTaskId === task.id ? 'ni-chevron-up' : 'ni-chevron-down'}`}
                                                            style={{ color: '#cbd5e1' }}></em>
                                                    </div>

                                                    {expandedTaskId === task.id && (
                                                        <div className="mt-3 p-3"
                                                            style={{
                                                                backgroundColor: 'rgba(15, 23, 42, 0.7)',
                                                                borderRadius: '12px',
                                                                border: '1px solid rgba(255,255,255,0.05)',
                                                                color: '#cbd5e1'
                                                            }}>
                                                            <p><strong style={{ color: '#f8fafc' }}>شرح:</strong> {task.description || '---'}</p>
                                                            {task.comments && task.comments.length > 0 && (
                                                                <div className="mb-2">
                                                                    <strong style={{ color: '#f8fafc' }}>مکاتبات:</strong>
                                                                    {task.comments.map(c => (
                                                                        <div key={c.id} className="ms-2 small border-bottom py-1"
                                                                            style={{ borderColor: 'rgba(255,255,255,0.1)', color: '#cbd5e1' }}>
                                                                            <em style={{ color: '#94a3b8' }}>{c.userName}</em> ({c.createdDatePersian}): {c.content}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            {task.documents && task.documents.length > 0 && (
                                                                <div>
                                                                    <strong style={{ color: '#f8fafc' }}>مدارک:</strong>
                                                                    <ul className="small" style={{ color: '#cbd5e1' }}>
                                                                        {task.documents.map(d => (
                                                                            <li key={d.id}>{d.fileName} ({d.documentType}) - {d.uploadDatePersian}</li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                            )
                        )}
                    </div>
                )}

                {/* ============= MODALS ============= */}
                {this.state.showObligationModal && (
                    <ObligationSelectorModal
                        show={this.state.showObligationModal}
                        contractId={this.state.record.id}
                        fiscalYear={this.state.record.fiscalYear}
                        onClose={() => this.setState({ showObligationModal: false })}
                        onSaved={() => { this.setState({ showObligationModal: false }); this.showSuccessMessage('وظایف ایجاد شدند.'); }}
                    />
                )}
                {this.state.showCustomObligationModal && (
                    <CustomObligationModal
                        show={this.state.showCustomObligationModal}
                        contractId={this.state.record.id}
                        onClose={() => this.setState({ showCustomObligationModal: false })}
                        onSaved={() => { this.setState({ showCustomObligationModal: false }); this.showSuccessMessage('وظایف با موفقیت اضافه شدند.'); }}
                    />
                )}
                {this.state.showDocsModal && (
                    <ContractDocumentsModal
                        show={this.state.showDocsModal}
                        contractId={this.state.record.id}
                        onClose={() => this.setState({ showDocsModal: false })}
                    />
                )}
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={{ global: this.state.data?.global }} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}